import { useState } from 'react';
import classNames from 'classnames';
import './FileItem.scss';
import Icon, { Icons } from '../../../../../components/Icon/Icon';
import ListItem from '../../../../../components/ListItem';
import RequestService from '../../../../../services/RequestService';
import HelperService from '../../../../../services/HelperService';
import { t } from '../../../../../lang';

const FileItem = ({ file, bottomSeparator }) => {
	const [isDownloading, setIsDownloading] = useState(false);
	const [isDownloaded, setIsDownloaded] = useState(false);

	const formatFileSize = bytes => {
		if (!bytes) return '0 KB';

		const kb = bytes / 1024;

		if (kb < 1024) {
			return `${Math.round(kb)} KB`;
		}

		const mb = kb / 1024;
		return `${mb.toFixed(1)} MB`;
	};

	const onDownload = async () => {
		if (isDownloading || isDownloaded) return;

		try {
			setIsDownloading(true);

			const response = await RequestService.FileDownload({ Id: file.Id });

			if (!response) {
				throw new Error('Download failed');
			}

			if (response?.code !== 'ERR_NETWORK') {
				HelperService.showNotification({
					type: 'success',
					title: t('Successful'),
				});
				setIsDownloaded(true);
				const url = window.URL.createObjectURL(new Blob([response]));
				const a = document.createElement('a');
				a.href = url;
				a.download = file.Name;
				document.body.appendChild(a);
				a.click();
				a.remove();
			}
		} catch (e) {
			HelperService.showNotification({
				type: 'error',
				title: t('Error'),
			});
		} finally {
			setIsDownloading(false);
		}
	};

	const isDisabled = isDownloading || isDownloaded;

	const rightTitle = (
		<Icon
			className={classNames('FileItem__download', {
				'FileItem__download--disabled': isDisabled,
			})}
			type={Icons.ARROW_SQUARE_DOWN}
			width={24}
			height={24}
			onClick={!isDisabled ? onDownload : undefined}
		/>
	);

	return (
		<ListItem
			className='FileItem'
			icon={'DOCUMENT_ICON'}
			iconSize='medium'
			title={file.Name}
			description={formatFileSize(file.Size)}
			rightTitle={rightTitle}
			bottomSeparator={bottomSeparator}
		/>
	);
};

export default FileItem;
